import axios from "axios";
import {
  config
} from "../config/config";
import store from "../store/index";
import {
  Toast
} from "mint-ui";
// axios default configs
// axios.defaults.baseURL = config.testUrl;
axios.defaults.baseURL = config.serverBaseUrl2;
axios.defaults.timeout = 30000;

function errToast(res) {
  let {
    code,
    warning
  } = res.data;
  console.log(res);
  code && code !== 200 && code !== 201 && Toast({
    message: warning,
    position: 'bottom',
    duration: 4000
  })
}

function httpGet(url, headers = null, showErr = true) {
  let options = !headers ? {} : {
    headers
  }
  return axios.get(url, options).then(res => {
    // showErr && errToast(res);
    let code = res.data.code;
    if(code && code !== 200 && code !== 201&& code !== 202){
      return Promise.reject(res.data.warning || res.data.message)
    }
    return res;
  })
}

function httpPost(url, data = {}, headers = null, showErr = true) {
  let options = !headers ? {} : {
    headers:headers
  }
  return axios.post(url, data, options).then(res => {
    // showErr && errToast(res);
    let code = res.data.code;
    if(code && code !== 200 && code !== 201&& code !== 202){
      return Promise.reject(res.data.warning || res.data.message)
    }
    return res;
  });
}

function httpDelete(url,isData=true,data={}) {
  let paramsobj = {
    ...isData&&{data},
    ...!isData&&{params:data}
  }
  return axios.delete(url, paramsobj).then(res => {
    console.log("这是httpdelete返的值：：：",res)
    // showErr && errToast(res);
    let code = res.data.code;
    if(code && code !== 200 && code !== 201&& code !== 202){
      return Promise.reject(res.data.warning || res.data.message)
    }
    return res;
  });
}

function httpPatch(url,data={}) {
  return axios.patch(url,data).then(res=>{
    console.log("这是httppatch返的值：：：",res)
    // showErr && errToast(res);
    let code = res.data.code;
    if(code && code !== 200 && code !== 201&& code !== 202){
      return Promise.reject(res.data.warning || res.data.message)
    }
    return res;
  })
}

function httpAll(promiseArr) {
  return httpAllHandle(promiseArr)
}
function httpAllHandle(promiseArr) {
  return Promise.all(promiseArr).then(res => {
    return res;
  });
}

axios.interceptors.request.use(
  config => {
    let platformInfo = store.state.platformInfo;
    let data = {
      ...platformInfo.platform && { "platform" : platformInfo.platform },
      ...platformInfo.appId && { "app-id" : platformInfo.appId},
      ...platformInfo.openid && { "openid" : platformInfo.openid },
      ...platformInfo.ID && { "ID" : platformInfo.ID },
      ...platformInfo["user-key"] && { "user-key" : platformInfo["user-key"] },
      ...platformInfo["user-key"] && {"Authorization":`Bearer ${platformInfo.ID}:${platformInfo["user-key"]}`}
    };
    config.url!=='http://101.132.238.119:8098/union_applet/union_wechat_signature'&&Object.keys(data).forEach(item=>{
      config.headers[item] = data[item];
    })
    return config
   },
   error => {
    return Promise.reject(error)
   }
)
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let message = ''
    if(/^4/.test(error.response.status)){
      message = error.response.data.message
    } else {
      message = "服务器异常"
    }
    return Promise.reject({success:false,message})
  }
)
//get openId
export const getOpenId = () =>{
  let platformInfo = store.state.platformInfo;
  let code = localStorage.getItem(`${platformInfo.appId}code`) || 'tcx';
  if(!platformInfo.code){
    let platformInfoRes = localStorage.getItem(`${platformInfo.appId}platformInfo`);
    if(platformInfoRes){
      store.commit("RECORD_PLATFORMINFO",JSON.parse(platformInfoRes));
      return Promise.resolve('获取成功');
    }
  }
  if(platformInfo.code==='feedback'){
	  return Promise.resolve('反馈页面');
  }
  if (code === platformInfo.code){
    let platformInfoRes = JSON.parse(localStorage.getItem(`${platformInfo.appId}platformInfo`));
    store.commit("RECORD_PLATFORMINFO",platformInfoRes);
    return Promise.resolve('获取成功');
  }
  else
  {
    localStorage.setItem(`${platformInfo.appId}code`,platformInfo.code);
    return httpPost(`${config.serverBaseUrl3}/union_applet/union_applet_get_openid`,{}, {
      code: platformInfo.code || ''
    }).then(res=> {
      let rd = res.data;
      let {ID, openid, judge } = rd;
      window.WebTrack && window.WebTrack.login(openid)
      platformInfo.ID=ID;
      platformInfo.judge = judge;
      platformInfo.openid=openid;
      platformInfo["user-key"]=rd["user-key"];
      store.commit("RECORD_PLATFORMINFO_LOCAL",platformInfo);
      return res;
    })
  }
}
// spec by id
export const specBySpecId = specificationID =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_specs_by_id/${specificationID}`);

// can print?
export const canPrint = specificationID =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_judge/${specificationID}`);
  // search by keywords
export const searchByKeywords = keywords =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_specs/${keywords}`);

  // make id photo 修改域名
export const wxGetKey = () =>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_applet_get_data`);

  //修改域名
export const getCloseList = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/formal_clothes`);

//创建电子照订单[data:{spec_id,spec_name,ori_file_name,final_pic_name,print_pic_name}]
export const eleOrder = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/ele_order`,data);

//电子订单列表
export const elelist = () =>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_applet_ele_list`);

//客服
export const service = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_service`);

//提取码
export const extractCode = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_applet_extract_code`,data);

//热搜
export const hotsearch = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_hot`);

//电子照发送邮件
export const elesendEmail = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_applet_send_email`,data)

//冲印获得价格
export const printGetPrice = () =>
  httpGet(`${config.printUrl}/app/price`)

//冲印获得省市区
export const printGetArea = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/divisions`)

//冲印获取快递时效
export const timeDivisions = ({code}) =>
  httpGet(`${config.printUrl}/divisions/${code}`)

//提交冲印订单前获取image_key这个参数来调用下一个接口
export const getImageKey = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/upload_image_new`,data)

//TODO加印照片功能新增额外规格信息
// export const getImageKey = (data={origin_name:'',file_path:'',consignee_name:'',consignee_phone:'',parameter:[{spec_id:-1,spec_name:'',colors:{enc_color:'',start_color:'',color_name:''},print_number:0,inputVal:''}]}) =>
//   httpPost(`${config.serverBaseUrl3}/union_applet/upload_image_new`,data)

//创建冲印订单
export const createPrint = (data) =>
  httpPost(`${config.printUrl}/app/user/orders`,data)

//获取冲印订单
export const getOrders = (params) => {
  let url = `${config.printUrl}/app/user/orders`
  for (let key in params) {
    if (!/\?/.test(url)) {
      url += `?${key}=${params[key]}`
    } else {
      url += `&${key}=${params[key]}`
    }
  }
  return httpGet(url);
}
//获取总价
export const checkMergeOrder = ({orderIdList = []}) => {
  if (!orderIdList.length)
    return Promise.resolve({})

  let url = `${config.printUrl}/app/user/merge_order/price`;
  let isfirst = '';
  let isAnd = '';
  orderIdList.forEach((item, index) => {
    isfirst = index === 0 ? '?' : '';
    isAnd = index > 0 ? '&' : '';
    url += `${isfirst}${isAnd}order_id[]=${item}`;
  });
  return httpGet(url);
}

//合并订单
export const submitMergeOrder = (formData) => 
httpPost(`${config.printUrl}/app/user/merge_order`, formData);

//请求支付接口
export const requestPayment = ({orderId, type}) => 
  httpPost(`${config.printUrl}/app/user/orders/${orderId}/${type}`);

//获取冲印订单详情
export const getOrderDetail = ({orderId}) =>
  httpGet(`${config.printUrl}/app/user/orders/${orderId}`);

// 获取快递信息
export const getExpressLog = ({orderId}) =>
  httpGet(`${config.printUrl}/app/user/orders/${orderId}/express-log`);

//发送冲印照到邮箱
export const sendEmail = ({orderId, email}) =>
  httpPost(`${config.printUrl}/app/user/send_email`, {
    order_id:orderId,
    email
  });

//制作图片接口 图片制作接口需要修改(参数form)
export const makephoto = ({spec_id,file}) =>{
  let df = new FormData();
  df.append("file",file);
  df.append("spec_id",spec_id);
  return httpPost(`${config.serverBaseUrl3}/union_applet/union_make_photo`,df);
}

//图片制作接口需要修改(参数post)
export const getphoto = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_make_photo`,data);

//获取价格接口需要修改
export const getprice = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/order_price`);

// //创建订单
export const createorder = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/generate_order`,data);
//创建测试订单
// export const createorder = (data) =>
//   httpPost(`${config.serverBaseUrl3}/union_applet/test_generate_order`,data);

//冲印水印获取排版url的接口
export const printImage = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/generate_print_image`,data);

//电子照重新支付
export const payAgain = ({order_id}) =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_pay_again?order_id=${order_id}`)

//获取9张规格图
export const ninePic =() =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_applet_nine_pic`)

//获取反馈类型
export const feedbackType =() =>
  httpGet(`${config.serverBaseUrl3}/union_applet/union_feedback_type`)

//意见反馈
export const feedback =({facility,applet_version,telephone,feedback_type,feedback_content,files})=>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_advertisement_question_feedback`,{
    facility,
    applet_version,
	  telephone,
	  feedback_type,
	  feedback_content,
	  files
  })

//获取教程图片
export const getTutorial = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/five_guide`)

//文本校验是否有敏感词
export const checkTxt = txt =>
  httpGet(`${config.printUrl}/app/user/test/scan?test=${txt}`)

//获取电子照的无水印图片
export const getUrls = orderId =>
  httpPost(`${config.serverBaseUrl3}/union_applet/union_applet_save_phone`,{order_id:orderId})

//获取电子照温馨提示信息
export const getListHint = () =>
  httpGet(`${config.serverBaseUrl3}/union_applet/list_hint`)

//获取混合订单列表
export const getMixOrder = (params) => {
  let url = 'app/user/mix-order';
  for (let key in params) {
    url += `${!/\?/.test(url)?'?':'&'}${key}=${params[key]}`
  }
  url = `${config.printUrl}/${url}`
  return httpGet(url);
}

//删除冲印订单接口
export const deleteOrder = (order_id) => httpDelete(`${config.printUrl}/app/user/orders/${order_id}`);

//删除冲印合并订单接口
export const deleteMergeOrder = (order_id) => httpDelete(`${config.printUrl}/app/user/merge-orders/${order_id}`);

//取消订单接口
export const cancelOrder = (order_id) => httpPatch(`${config.printUrl}/app/user/orders/${order_id}`,[{
  op:'replace',
  path:"/state",
  value:"canceled"
}])

export const modifyAddress = (orderid, user_address_division, user_name, user_phone, user_address_detail) =>
  httpPatch(`${config.printUrl}/app/user/orders/${orderid}`,[{
    op: 'replace',
    path: "/user_address_division",
    value: user_address_division
  }, {
    op: 'replace',
    path: "/user_name",
    value: user_name
  }, {
    op: 'replace',
    path: "/user_phone",
    value: user_phone
  }, {
    op: 'replace',
    path: "/user_address_detail",
    value: user_address_detail
  }])

export const makephotov1 = ({spec_id,file}) => {
  let df = new FormData();
  df.append("file",file);
  df.append("spec_id",spec_id);
  return httpPost(`${config.serverBaseUrl3}/union_applet/union_make_photo_v1`,df)
}

export const asyncresult = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/asynchronous_result`,data)

export const makephotovJson = (data) => {
  return httpPost(`${config.serverBaseUrl3}/union_applet/union_make_photo_v1`,data)
}

export const makewedding = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/wedding_cut`,data)

export const asyncwedding = (data) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/wedding_asynchronous_result`,data)

//追加冲印*****************************************************************
export const print_append_order = (data) =>
  httpPost(`${config.serverBaseUrl3}/proportion/print_append_order`,data)

export const getchannel = () =>
  httpGet(`${config.printUrl}/app/order/channel`)

export const commonSpecs = ({spec_id,spec_name}) =>
  httpGet(`${config.printUrl}/app/specs?spec_id=${spec_id}&spec_name=${encodeURIComponent(spec_name)}`)

export const getSpecImage = (data) =>
  httpPost(`${config.printUrl}/tasks/generate-spec-image`,data)

export const gettaskid = (id) =>
  httpGet(`${config.printUrl}/tasks/${id}`)

// 图片文字校验***********************************************************
export const getOssUrl = ()=>
  httpGet(`${config.serverBaseUrl3}/union_applet/applet_upload_oss`)

export const PostUrl = (url,data) =>
  httpPost(url,data)

export const picTest = (key) =>
  httpGet(`${config.serverBaseUrl3}/union_applet/app/pic-testing?image_key=${key}`)

export const font_test = (text) =>
  httpPost(`${config.serverBaseUrl3}/union_applet/app/text-testing`,{text})